import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import { useTabSelectWithClearSearch } from "../../../util/useTabSelectWithClearSearch";
import UserChannel from "./UserChannel";
import FakeChannel from "./FakeChannel";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getChannelStatsData } from "../../store/user/user.action";
import StatsCards from "../../extra/StatsCards";
import {
  IconBrandYoutube,
  IconCash,
  IconUserCheck,
  IconUserQuestion,
  IconUsers,
} from "@tabler/icons-react";

export default function ChannelPage() {
  const dispatch = useDispatch();
  const { multiButtonSelect, handleMultiButtonSelect } =
    useTabSelectWithClearSearch("User Channel");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const { isLoading } = useSelector((state) => state.dialogue);
  const { channelStatsData } = useSelector((state) => state.user);

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getChannelStatsData(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  const statsCards = [
    {
      title: "Total Channels",
      count: channelStatsData?.totalChannels,
      Icon: IconBrandYoutube,
    },
    {
      title: "Total Real Channels",
      count: channelStatsData?.totalRealChannels,
      Icon: IconUserCheck,
    },
    {
      title: "Total Fake Channels",
      count: channelStatsData?.totalFakeChannels,
      Icon: IconUserQuestion,
    },
    {
      title: "Total Subscribers",
      count: channelStatsData?.totalSubscribers,
      Icon: IconUsers,
    },
  ];

  return (
    <div className="userPage channelPage">
      <div>
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={true}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            setMultiButtonSelect={handleMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
            labelData={["User Channel", "Fake User Channel"]}
            loading={isLoading}
          />
        </div>
        <StatsCards cards={statsCards} />
      </div>
      {multiButtonSelect == "User Channel" && (
        <UserChannel startDate={startDateData} endDate={endDateData} />
      )}
      {multiButtonSelect == "Fake User Channel" && (
        <FakeChannel startDate={startDateData} endDate={endDateData} />
      )}
    </div>
  );
}
